<template>
  <v-menu style="z-index: 999;">
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon v-on:click.prevent v-bind="attrs" v-on="on" class="context-menu-room-compactmode mx-4" style="float: right;">
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </template>
    <v-list dense v-if="room">
      <v-list-item
        v-for="(contextMenu, index) in room.actions"
        :key="index"
        @click="onRoomAction(contextMenu, room)"
      >
        <v-list-item-icon>
          <v-icon :color="contextMenu.color">{{ contextMenu.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-title>{{ capitalizeFirstLetter($t(`chat.contextMenu.${contextMenu.key}`)) }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import MixinChatRoomActions from '@/mixins/chat/room_actions'
import MixinChatHelper from '@/mixins/chat/helper'

export default {
  name: 'chat-room-actions-menu',
  props: ['room'],
  mixins: [
    MixinChatHelper,
    MixinChatRoomActions
  ]
}
</script>

<style>
</style>
